import { ApiError } from "../../shared/errors/ApiError";
import { getSelectedAccountId } from "../../shared/lib/auth/accountContext";
import { getTokenData } from "./getTokenData";

export async function getAuthHeaders({
  includeAccountContext = true,
  authorizationToken = "access",
} = {}) {
  const { client_id, email, token } = await getTokenData();

  if (!token) {
    throw new ApiError({
      error: "auth_error",
      message: "Token de autenticação não encontrado",
    });
  }

  if (!client_id) {
    throw new ApiError({
      error: "auth_error",
      message: "ID do cliente não encontrado",
    });
  }

  const selectedAccountId = getSelectedAccountId(email);
  const headers = {
    Authorization: authorizationToken === "id" ? client_id : token,
    Client_ID: client_id,
  };

  if (includeAccountContext && selectedAccountId) {
    headers["x-account-id"] = selectedAccountId;
  }

  return headers;
}
